import { ActionTree, GetterTree, Module, MutationTree } from 'vuex'
import {
  Actions,
  Getters,
  Mutations,
  ModalEditMobileState,
} from '@/interfaces/store/modalEditMobile'
import { RootState } from '@/interfaces/store/root'
import { CustomerProfilesDopa } from '@/interfaces/customer-profiles'

export const state: ModalEditMobileState = {
  isModalActive: false,
  isModalClose: false,
  isStep: '',
  refCode: '',
  newMobileNumber: '',
  level: 'L1',
  l1Token: '',
  l2Token: '',
  customerList: [],
  customerProfileDopa: []
}

export const getters: GetterTree<ModalEditMobileState, RootState> & Getters = {}
export const actions: ActionTree<ModalEditMobileState, RootState> & Actions = {
  onOpen({ commit }) {
    commit('updateModalClose', false)
    commit('updateModalActive', true)
  },
  onClose({ commit }) {
    commit('updateModalClose', true)
    setTimeout(() => {
      commit('updateModalActive', false)
    }, 500)
  },
  onResetStep({ commit }) {
    commit('updateStep', '')
    commit('updateOtpRefCode', '')
    commit('updateNewMobileNumber', '')
    commit('updateLevel', 'L1')
    commit('updateL1Token', '')
    commit('updateL2Token', '')
    commit('updateCustomerList', [])
    commit('updateCustomerProfileDopa', [])
  },
}

export const mutations: MutationTree<ModalEditMobileState> & Mutations = {
  updateModalActive(state: ModalEditMobileState, isModalActive: boolean) {
    state.isModalActive = isModalActive
  },
  updateModalClose(state: ModalEditMobileState, isModalClose: boolean) {
    state.isModalClose = isModalClose
  },
  updateStep(state: ModalEditMobileState, step: string) {
    state.isStep = step
  },
  updateOtpRefCode(state: ModalEditMobileState, refCode: string) {
    state.refCode = refCode
  },
  updateNewMobileNumber(state: ModalEditMobileState, newMobileNumber: string) {
    state.newMobileNumber = newMobileNumber
  },
  updateLevel(state: ModalEditMobileState, level: string) {
    state.level = level
  },
  updateL1Token(state: ModalEditMobileState, l1Token: string) {
    state.l1Token = l1Token
  },
  updateL2Token(state: ModalEditMobileState, l2Token: string) {
    state.l2Token = l2Token
  },
  updateCustomerList(state: ModalEditMobileState, customerList: any[]) {
    state.customerList = customerList
  },
  updateCustomerProfileDopa(state: ModalEditMobileState, customerProfileDopa: CustomerProfilesDopa[]) {
    state.customerProfileDopa = customerProfileDopa
  },
}

export const store: Module<ModalEditMobileState, RootState> = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
